import { DownloadIcon } from "lucide-react";
// import { useState } from "react";

const PriceBreakup = ({ data }) => {
  // const [openPrice, setOpenPrice] = useState(false);
  // const [openPayment, setOpenPayment] = useState(false);
  if (!data) return null;

  const {
    online_paid_product_before_tax,
    cart_collect_on_delivery_amt,
    online_paid_amt_tax,
    product_shipping_charges_amt,
    product_packing_and_forwarding_charges_amt,
    promo_coupons_value,
    total_amount_paid_amt,
    wallet_paid_amt,
    points_used,
    b2bcredits,
    invoice,
  } = data;

  // const handleInvoice = () => window.open(invoice);
  const handleInvoice = () => {
    const link = document.createElement("a");
    link.href = invoice; // your S3 URL
    link.target = "_blank";
    link.download = "invoice.pdf"; // suggested filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const subTotalBeforeTax = Number(online_paid_product_before_tax || 0);
  const tax = Number(online_paid_amt_tax || 0);
  const subTotalAfterTax = subTotalBeforeTax + tax;

  return (
    <div className="flex-1 max-w-[600px] md:mt-[50px]">
      <div className="space-y-4">
        {/* PRICE BREAKUP */}
        <div className="border border-gray-200 rounded-xl bg-white">
          <button
            // onClick={() => setOpenPrice(!openPrice)}
            className="w-full flex items-center justify-between px-5 py-3 font-semibold"
          >
            <span>Price Breakup</span>
            {invoice && (
              <div className="flex justify-end">
                <span
                  className="flex items-center gap-2 text-blue-700 cursor-pointer hover:text-gray-400 transition-all text-sm"
                  onClick={handleInvoice}
                >
                  <DownloadIcon className="cursor-pointer" size={16} /> Download
                  Invoice
                </span>
              </div>
            )}
            {/* <span className="text-xl">{openPrice ?  <ChevronUp/> : <ChevronDown/>}</span> */}
          </button>

          {
            <div className="px-5 pb-4 space-y-3 text-sm">
              <Row
                label="Subtotal (Before Tax)"
                value={`₹ ${subTotalBeforeTax}`}
              />
              <Row label="Tax" value={`₹ ${tax}`} />

              {Number(promo_coupons_value) > 0 && (
                <Row
                  label="Coupon Discount"
                  value={`-₹ ${Number(promo_coupons_value || 0).toFixed(0)}`}
                />
              )}

              <Row
                label="Delivery Charges"
                value={
                  Number(product_shipping_charges_amt) === 0
                    ? "Free"
                    : `₹ ${Number(product_shipping_charges_amt)}`
                }
              />

              <Row
                label="Packing & Forwarding Charges"
                value={
                  Number(product_packing_and_forwarding_charges_amt) === 0
                    ? "Free"
                    : `₹ ${Number(product_packing_and_forwarding_charges_amt)}`
                }
              />

              <Divider />

              <Row
                label={
                  <span className="font-semibold">Subtotal (After Tax)</span>
                }
                value={`₹ ${subTotalAfterTax.toFixed(2)}`}
              />
            </div>
          }
        </div>

        {/* PAYMENT BREAKUP */}
        <div className="border border-gray-200 rounded-xl bg-white">
          <button
            // onClick={() => setOpenPayment(!openPayment)}
            className="w-full flex items-center justify-between px-5 py-3 font-semibold"
          >
            <span>Payment Breakup</span>
            {/* <span className="text-xl">{openPayment ? <ChevronUp/> : <ChevronDown/>}</span> */}
          </button>

          {
            <div className="px-5 pb-4 space-y-2 text-sm">
              {Number(wallet_paid_amt) > 0 && (
                <Row label="Wallet Used" value={`₹ ${wallet_paid_amt}`} />
              )}

              {Number(points_used) > 0 && (
                <Row label="Points Used" value={`₹ ${points_used}`} />
              )}

              {Number(b2bcredits) > 0 && (
                <Row label="Credit Used" value={`₹ ${b2bcredits}`} />
              )}

              {Number(cart_collect_on_delivery_amt) > 0 && (
                <Row
                  label="COD Payment"
                  value={`₹ ${cart_collect_on_delivery_amt}`}
                />
              )}

              <Divider />

              <Row
                label={<span className="font-semibold">Total </span>}
                value={`₹ ${Number(total_amount_paid_amt || 0).toFixed(2)}`}
              />
            </div>
          }
        </div>
      </div>
    </div>
  );
};

function Row({ label, value }) {
  return (
    <div className="flex justify-between">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}

function Divider() {
  return <div className="border-t border-gray-200 my-2" />;
}

export default PriceBreakup;
